/**
 * vjiang
 * 20200821
 * public interface
 */

import request from '@/utils/request';

/**
 * 获取手机验证码
 * @param {openid,phoneNumber}
 */
export function getCode(params) {
    return request({
        url: '/business/captcha',
        method: 'get',
        params: params
    })
}

/**
 * 获取购卡套餐列表
 * @param params
 * @param type == 0查询list 1 单条查询
 */
export function getSetMeal(params, type = 0) {
    return request({
        url: "/business/MagProduct/" + (type === 0 ? 'list' : 'getInfo'),
        method: "get",
        params: params
    })
}

/**
 * 获取预约列表
 * @param params
 */
export function getAppointmentList(params) {
    return request({
        url: "/business/MagPre/list",
        method: "get",
        params: params
    })
}

/**
 * 新增预约
 * @param data
 */
export function addAppiontment(data) {
    return request({
        url: "/business/MagPre/add",
        method: "post",
        data: data
    })
}

/**
 * 编辑预约
 * @param data
 */
export function updateAppiontment(data) {
    return request({
        url: "/business/MagPre/update",
        method: "post",
        data: data
    })
}

/**
 * 预约取消删除
 * @param params
 */
export function delAppiontment(params) {
    return request({
        url: "/business/MagPre/delete",
        method: "get",
        params: params
    })
}

/**
 * 预约详情
 * @param data
 */
export function getAppiontmentDetail(params) {
    return request({
        url: "/business/MagPre/getInfo",
        method: "get",
        params: params
    })
}

/**
 * 获取可预约日期列表
 * @param data
 */
export function getCanDate(params) {
    return request({
        url: "/business/MagPreConfig/list/month",
        method: "get",
        params: params
    })
}

/**
 * 查询体检预约提示信息
 * @returns 
 */
export function getPreMessage(params) {
    return request({
        url: "/business/MagPre/getPreMessage",
        method: "get",
        params: params
    })
}

/**
 * 获取用户的openid
 * @param params
 */
export function gainOpenid(params) {
    return request({
        url: "/business/getOpenId",
        method: "get",
        params: params
    })
}

/**
 * 获取公司简介、体检须知、体检引导等信息
 * @param params
 */
export function gainContent(params) {
    return request({
        url: "/business/MagParamConfig/value",
        method: "get",
        params: params
    })
}

/**
 * 获取分院信息
 */
export function gainBranchInformation(params) {
    return request({
        url: "/business/MagBranchCourts/list",
        method: "get",
        params: params
    })
}

/**
 * 新增职业病基本信息
 * @param data
 */
export function addMagOccupatDisea(data) {
    return request({
        url: "/business/MagOccupatDisea/add",
        method: "post",
        data: data
    })
}

/**
 * 新增职业史信息
 * @param data
 */
export function addMagOccupatHist(data) {
    return request({
        url: "/business/MagOccupatHist/add",
        method: "post",
        data: data
    })
}

/**
 * 新增职业病症状
 * @param data
 */
export function addMagSymptom(data) {
    return request({
        url: "/business/MagSymptom/add",
        method: "post",
        data: data
    })
}

/**
 * 新增职业病信息
 * @param data
 */
export function addAll(data) {
    return request({
        url: "/business/MagOccupatDisea/addAll",
        method: "post",
        data: data
    })
}

/**
 * 获取职业病信息
 */
export function getAll(params) {
    return request({
        url: "/business/MagOccupatDisea/getAll/" + params,
        method: "get",
    })
}